import api from '@/lib/axios'

export interface LocalizedString {
    tr: string
    en?: string
    nl?: string
    fr?: string
    ar?: string
    ru?: string
    es?: string
}

export interface JobListing {
    id: string
    title: LocalizedString
    description: LocalizedString
    department: LocalizedString
    type: LocalizedString
    location: LocalizedString
    experience?: LocalizedString
    status: 'active' | 'closed'
    createdAt: string
}

export interface CareerPageFeature {
    icon: string
    title: LocalizedString
    description: LocalizedString
}

export interface CareerPageContent {
    hero: {
        title: LocalizedString
        subtitle: LocalizedString
    }
    features: CareerPageFeature[]
}

export const careerService = {
    // Page Content
    getContent: async () => {
        const res = await api.get<CareerPageContent>('/career/content')
        return res.data
    },
    updateContent: async (data: CareerPageContent, translate = false) => {
        const res = await api.put<CareerPageContent>(`/career/content?translate=${translate}`, data)
        return res.data
    },

    // Job Listings
    getJobs: async (status?: string) => {
        const res = await api.get<JobListing[]>('/career/jobs', { params: { status } })
        return res.data.map(j => ({ ...j, id: (j as any)._id || j.id }))
    },
    getJobById: async (id: string) => {
        const res = await api.get<JobListing>(`/career/jobs/${id}`)
        return { ...res.data, id: (res.data as any)._id || res.data.id }
    },
    createJob: async (data: Partial<JobListing>, translate = false) => {
        const res = await api.post<JobListing>(`/career/jobs?translate=${translate}`, data)
        return res.data
    },
    updateJob: async (id: string, data: Partial<JobListing>, translate = false) => {
        const res = await api.put<JobListing>(`/career/jobs/${id}?translate=${translate}`, data)
        return res.data
    },
    deleteJob: async (id: string) => {
        const res = await api.delete(`/career/jobs/${id}`)
        return res.data
    }
}
